import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
/*
  Generated class for the OemProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

import { environment } from '../../environments/environment';
const CLOUD_FUNC_URL = environment.cloudUrl;

@Injectable()
export class OemProvider {
  
  oemFieldRepsCollection: AngularFirestoreCollection<any>;
  oemFieldReps$:Observable<any[]>;
  oemFieldReps:Array<any>;
  oemFieldRepsSubs:Subscription;
  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events,private http: HttpClient) {
    console.log('Hello OemProvider Provider');
  }


   intializeSubscriptions(){

      this.oemFieldRepsCollection = this.afs.collection<any>('oemFieldReps');
      this.oemFieldReps$ = this.oemFieldRepsCollection.snapshotChanges().pipe(
          map(actions => actions.map(a => {
            const data = a.payload.doc.data();
            const id = a.payload.doc.id;
            return data;
         })));
    
     this.oemFieldRepsSubs = this.oemFieldReps$.subscribe( (oemFieldReps:any) => {  

            this.oemFieldReps = oemFieldReps;
            console.log(oemFieldReps);
            this.events.publish('oem:oemFieldRepsList',this.oemFieldReps);
     });

     this.events.subscribe('oem:getOemFieldRepsList', () => {

        this.events.publish('oem:oemFieldRepsList',this.oemFieldReps);

     });

      this.events.subscribe('oem:addOemFieldRep', (oemFieldRep:any) => {

        this.addOemFieldRep(oemFieldRep);

      });

       this.events.subscribe('oem:updateOemFieldRep', (oemFieldRep:any) => {

        this.updateOemFieldRep(oemFieldRep);

      });

   }

   async addOemFieldRep(oemFieldRep){

          this.http.post(CLOUD_FUNC_URL + 'addOemFieldRep',oemFieldRep).subscribe((res: any) => {
                    console.log(res);
                    if (res.success) {
                       this.events.publish('oem:addOemFieldRepSuccess');
                    }
                    else{
                       this.events.publish('oem:addOemFieldRepFailed');
                    }

         });

   }

   async updateOemFieldRep(oemFieldRep){

     if(oemFieldRep && oemFieldRep.uid){
        await this.afs.collection('users').doc(oemFieldRep.uid).update(oemFieldRep);
        await this.afs.collection('oemFieldReps').doc(oemFieldRep.uid).update(oemFieldRep);

        this.events.publish('oem:updateOemFieldRepSuccess');
     }
     else{
       this.events.publish('oem:updateOemFieldRepFailed');
     }
    
   }

 

   removeSubscriptions(){
      if(this.oemFieldRepsSubs){
           this.oemFieldRepsSubs.unsubscribe();
      }
      this.events.unsubscribe('oem:addOemFieldRep');
      this.events.unsubscribe('oem:getOemFieldRepsList');
      this.events.unsubscribe('oem:updateOemFieldRep');
   }


}



// WEBPACK FOOTER //
// ./src/providers/oem/oem.ts